module.exports = __webpack_public_path__ + "img/map-marker-alt-solid.799a7977.svg";